export default {"src":"/_next/static/media/stay_secure.fc8325ab.svg","height":111,"width":365,"blurWidth":0,"blurHeight":0};